
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { Card } from "@/components/ui/card";
import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const SuccessStories = () => {
  const [api, setApi] = useState<any>();
  const [current, setCurrent] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: "Sandra L.",
      image: "/lovable-uploads/52ba26e2-beb8-449d-b45e-1c79a35ff569.png",
      quote: "Metrade is the perfect solution! I use the free strategies to learn about different trading styles. If I like one, I switch to a pro strategy. I simply follow the professionals on the marketplace and benefit from their expertise!"
    },
    {
      id: 2,
      name: "Emma T.",
      image: "/lovable-uploads/00a1e983-7e40-4935-a7fa-a37732f37cae.png",
      quote: "As a beginner in crypto trading, Metrade's platform made it easy for me to start with proven strategies. The results have been phenomenal!"
    },
    {
      id: 3,
      name: "Michael R.",
      image: "/lovable-uploads/bd804d9c-7963-4f73-823a-99c639c20d95.png",
      quote: "The automated trading strategies have completely transformed how I approach crypto trading. The transparency and professional oversight give me peace of mind."
    },
    {
      id: 4,
      name: "David K.",
      image: "/lovable-uploads/22423728-9e0c-4233-a65d-abefd5564a36.png",
      quote: "The quality of strategies available on Metrade is outstanding. Being able to verify performance in real-time makes all the difference."
    }
  ];

  useEffect(() => {
    if (!api) return;

    api.on("select", () => {
      setCurrent(api.selectedScrollSnap());
    });
  }, [api]);

  const scrollTo = (index: number) => {
    api?.scrollTo(index);
  };

  return (
    <section className="py-24 px-4 bg-corporate-white border-t border-corporate-neutral-25">
      <div className="container mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-corporate-primary-75 mb-4">
            Success stories of our customers
          </h2>
          <p className="text-corporate-neutral-75 text-lg max-w-2xl mx-auto">
            Trust through success - hear what our users have to say
          </p>
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="relative max-w-4xl mx-auto"
        >
          <Carousel
            setApi={setApi}
            className="w-full"
            opts={{
              align: "center",
              loop: true,
            }}
          >
            <CarouselContent>
              {testimonials.map((testimonial) => (
                <CarouselItem key={testimonial.id}>
                  <Card className="p-8 md:p-10 border border-corporate-neutral-25 hover:shadow-md transition-all duration-300">
                    <div className="flex flex-col md:flex-row items-center gap-8">
                      <div className="flex-shrink-0">
                        <img
                          src={testimonial.image}
                          alt={`${testimonial.name}'s testimonial`}
                          className="w-28 h-28 rounded-full object-cover border-2 border-corporate-primary-75 shadow-md"
                        />
                      </div>
                      <div className="flex-1 text-center md:text-left">
                        <p className="text-lg md:text-xl text-corporate-neutral-100 mb-6 italic leading-relaxed">
                          "{testimonial.quote}"
                        </p>
                        <p className="font-semibold text-corporate-primary-75 text-lg">
                          {testimonial.name}
                        </p>
                      </div>
                    </div>
                  </Card>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="hidden md:flex border border-corporate-primary-75 text-corporate-primary-75" />
            <CarouselNext className="hidden md:flex border border-corporate-primary-75 text-corporate-primary-75" />
          </Carousel>

          <div className="flex justify-center gap-3 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => scrollTo(index)}
                className={`w-3 h-3 rounded-full transition-colors ${
                  current === index ? "bg-corporate-primary-75" : "bg-corporate-neutral-25"
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default SuccessStories;
